/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
  thousandSeparatorByCurrency,
  decimalSeparatorByCurrency,
  decimalScaleByCurrency,
} from "../../utils/Currency";
import NumberFormat from "react-number-format";
import * as Notification from "../../Notification";
import FormInput from "../../components/FormCustom2/Input";
import { Copy } from "../../components/Copy";
import { Copy_Link } from "../../components/Copy-Link";
import {
  itemDetail,
  itemsBreed,
  getDexWallet,
  itemMove,
  itemDetailMarket,
  itemsSku,
} from "../../services/app";
import { dateFormat } from "../../utils/helper";
import { CopyIcon3 } from "../../components/Icons/CopyIcon";
import { ModalConfirmSync } from "./components/ModalConfirmSync";
import { ModalSubAlert } from "./components/ModalSubAlert";
import { ModalMintNotify } from "../../components/ModalMintNotify";
import { useApp } from "../../contexts";
import { useWindowSize } from "../../hook/useWindowSize";
import { ArrowDownIcon } from "../../components/Icons/ArrowDownIcon";
import { IconFemale } from "../../components/Icons/IconFemale";
import { useNavigate, useParams } from "react-router-dom";
import {
  formatCurrency,
  createDexWallet,
  postChangeDescriptionNft,
  postChangeNameNft,
} from "../../services/app";
import { ITEM_POSITION_ENUMS, ITEM_TYPES } from "../../constants";
import { getPropByLanguage } from "../../utils/Language";
import { IconSend } from "../../components/Icons/IconSend";
import CustomVideo from "../../components/video/CustomVideo";
import VideoPlayer from "../../components/video/MobileVideo";
import ImageCustom from "../../components/imageCustom/ImageCustom";
import { PREPOSITION } from "../Home";

export const EarnerDetail = () => {
  const {
    T: t,
    loading,
    setLoading,
    language,
    convertToLocalCurrency,
    getCurrency,
    setPrePosition,
  } = useApp();

  let { id } = useParams();
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  const navigate = useNavigate();
  const back = () => navigate(-1);
  const [randomClass, setRandomClass] = useState("");
  const [breedOptions, setBreedOptions] = useState([]);
  const [rankOptions, setRankOptions] = useState([]);
  const [skuOptions, setSkuOptions] = useState([]);
  const [itemData, setItemData] = useState(null);
  const [subData, setSubData] = useState([]);
  const [currentSub, setCurrentSub] = useState([]);
  const [opportunityTokens, setOpportunityTokens] = useState([]);
  const [metadataOnchain, setMetadataOnchain] = useState({});
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState(0);
  const [subTotalPrice, setSubTotalPrice] = useState(0);
  const [categorySelected, setCategorySelected] = useState({});
  const [skuSelected, setSkuSelected] = useState({});
  const [openProperties, setOpenProperties] = useState(true);
  const [openOpportunityTokens, setOpenOpportunityTokens] = useState(true);
  const [openMintings, setOpenMintings] = useState(true);
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
  const [isBtnLoading, $isBtnLoading] = useState(false);
  const [isDesEdit, setIsDesEdit] = useState(false);
  const [isNameEdit, setIsNameEdit] = useState(false);
  const [isOpenModalSubAlert, setIsOpenModalSubAlert] = useState(false);
  const [breadName, setBreadName] = useState("");
  const [totalSub, setTotalSub] = useState(0);
  const [rankName, setRankName] = useState("");
  const [rankCode, setRankCode] = useState("");
  const [idv2, setIdv2] = useState(null);
  const [isShowCreateWeb3, setIsShowCreatWeb3] = useState(false);
  const [isShowCreateWeb3Success, setIsShowCreatWeb3Success] = useState(false);
  const [collectionName, setCollectionName] = useState("");
  const [collectionList, setCollectionList] = useState([]);
  const propLang = getPropByLanguage(language);

  useEffect(() => {
    const arr = Array.from({ length: 7 }, (_, i) => i + 1);
    const random = itemData?.id % 7;
    setRandomClass(
      itemData?.item_type === ITEM_TYPES.ITEM_TYPE_PRIME
        ? ""
        : `suzu-card-image-${arr[random]}`
    );
  }, [itemData]);

  useEffect(() => {
    loadData();
    setPrePosition(PREPOSITION.EARNER);
  }, []);

  useEffect(() => {
    if (itemData?.item_type === ITEM_TYPES.ITEM_TYPE_PRIME) {
      if (itemData && skuOptions?.length > 0) {
        const breedSelected = skuOptions.find(
          (item) => item.sku === itemData?.sku
        );
        if (breedSelected) {
          setBreadName(breedSelected.description);
          setSkuSelected(breedSelected);
        }
      }
    } else {
      if (itemData && breedOptions?.length > 0) {
        const breedSelected = breedOptions.find(
          (item) => item.id === itemData?.nft_type_category_id
        );
        if (breedSelected) {
          setBreadName(
            breedSelected.nameTranslate[getPropByLanguage(language)]
          );
          setCategorySelected(breedSelected);
        }
      }
      if (itemData && rankOptions?.length > 0) {
        const dogLevelsSelected = rankOptions?.find(
          (lvl) => lvl.rankCode == itemData?.rankCode
        );
        setRankCode(dogLevelsSelected?.rankCode || "");
        setRankName(
          dogLevelsSelected?.rankNameTranslate[getPropByLanguage(language)] ||
            ""
        );
      }
    }
  }, [breedOptions, itemData, language, rankOptions]);

  const loadData = async () => {
    setLoading(true);
    const result = await Promise.all([
      itemDetail(id),
      itemsBreed(ITEM_TYPES.ITEM_TYPE_DOG),
      itemsSku(ITEM_TYPES.ITEM_TYPE_PRIME),
    ]);
    if (!result[0]?.data?.data?.item) {
      navigate(`/404`);
      return;
    }
    setItemData(result[0]?.data?.data?.item || null);
    setSubData(result[0]?.data?.data?.allSubscriptions || []);
    setOpportunityTokens(result[0]?.data?.data?.opportunityTokens || []);
    setCurrentSub(
      result[0]?.data?.data?.allSubscriptions?.[0]?.subs?.[0] || null
    );

    setMetadataOnchain(result[0]?.data?.data?.metadataOnchain);
    setDescription(result[0]?.data?.data?.metadataOnchain?.description || "");
    setBreedOptions(result[1]?.data?.data?.categories || []);
    setRankOptions(result[1]?.data?.data?.nftRanks || []);
    setCollectionList(result[1]?.data?.data?.nftCollections || []);

    setSkuOptions(result[2]?.data?.data || []);
    loadItemV2(result[0]?.data?.data?.item?.token);
    setLoading(false);
  };
  useEffect(() => {
    if (collectionList.length > 0 && itemData) {
      const collectionSelected = collectionList.find(
        (i) => i.collectionGroup === itemData?.collection_code_name
      );
      setCollectionName(
        collectionSelected?.groupNameTranslate[propLang] ||
          collectionSelected?.defaultName
      );
    }
  }, [collectionList, itemData]);

  useEffect(() => {
    if (subData.length > 0) {
      subData.forEach((item) => {
        const itemSubActive = (item?.subs || []).filter(
          (i) => i.status === true
        );
        if (itemSubActive.length > 0) {
          setCurrentSub(itemSubActive[0] || null);
        }
      });
    }
  }, [subData]);
  const hanldeCreateWeb3Address = async () => {
    try {
      if (isBtnLoading) return;
      $isBtnLoading(true);
      const createResult = await createDexWallet();
      if (createResult?.data?.error?.status) {
        setIsShowCreatWeb3(false);
        setIsShowCreatWeb3Success(true);
      } else {
        Notification.error(t(createResult?.data?.error?.message));
        setIsShowCreatWeb3(false);
      }
    } catch (e) {
      Notification.error(t("Create web3 wallet unsuccessfully"));
      setIsShowCreatWeb3(false);
    }
    $isBtnLoading(false);
  };
  const isAcceptToMoveMarket = useMemo(() => {
    if (subData.length > 0) {
      return subData.every((item) => {
        return item.subs.every((i) => i.user_canceled !== 0);
      });
    }
    return true;
  }, [subData]);
  const changeDescription = (val) => {
    if (val.trim().length >= 5000 || !isDesEdit) return;
    setDescription(val);
  };
  const changeName = (val) => {
    if (val.trim().length >= 100 || !isNameEdit) return;
    setName(val);
  };
  const loadItemV2 = (token) => {
    itemDetailMarket(token).then((res) => {
      const idv2 = res?.data?.data?.idV2 || null;
      if (idv2) setIdv2(idv2);
    });
  };
  useEffect(() => {
    if (itemData) {
      setPrice(
        convertToLocalCurrency(
          itemData.ccy ? itemData.price : itemData.price_in_usd,
          itemData.ccy ? itemData.ccy : "USD",
          getCurrency()
        )
      );
      if (itemData?.item_type === ITEM_TYPES.ITEM_TYPE_PRIME) {
        setPrePosition("nft_prime");
      } else {
        setPrePosition(PREPOSITION.EARNER);
      }
    }
  }, [itemData]);

  useEffect(() => {
    if (subData && subData.length > 0) {
      const subTotal = subData.reduce((summarySub, sub) => {
        const subTotalChild = sub.subs.reduce(
          (summaryChild, subChild) =>
            summaryChild + Number(subChild.price_in_usd),
          0
        );
        return summarySub + subTotalChild;
      }, 0);
      const countSub = subData.reduce((summarySub, sub) => {
        return summarySub + sub.subs?.length;
      }, 0);
      setSubTotalPrice(convertToLocalCurrency(subTotal, "USD", getCurrency()));
      setTotalSub(countSub);
    }
  }, [subData]);

  const handleMoveItem = (item) => {
    const params = {
      itemId: item.id,
      currentPosition: item.position,
      newPosition:
        item.position === ITEM_POSITION_ENUMS.ITEM_POSITION_APP
          ? ITEM_POSITION_ENUMS.ITEM_POSITION_MARKETPLACE
          : ITEM_POSITION_ENUMS.ITEM_POSITION_APP,
    };
    setLoading(true);
    itemMove(params)
      .then((res) => {
        setIsOpenModalConfirm(false);
        setLoading(false);
        if (res?.data?.data?.status) {
          setItemData(res?.data?.data?.data?.item);
          loadData();
          if (params.currentPosition == ITEM_POSITION_ENUMS.ITEM_POSITION_APP) {
            Notification.success(t("Successfully moved to C2C market."));
            loadItemV2(res?.data?.data?.data?.item?.token);
          } else {
            Notification.success(t("Successfully synced to app"));
          }
        } else {
          if (params.currentPosition == ITEM_POSITION_ENUMS.ITEM_POSITION_APP) {
            Notification.error(
              t(
                "You can only move earner to C2C market after owning it for 1 year."
              )
            );
          } else {
            Notification.error(
              t("Please go to C2C market and unlist your item first.")
            );
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        if (params.currentPosition == ITEM_POSITION_ENUMS.ITEM_POSITION_APP) {
          Notification.error(
            t(
              "You can only move earner to C2C market after owning it for 1 year."
            )
          );
        } else {
          Notification.error(
            t("Please go to C2C market and unlist your item first.")
          );
        }
      });
  };
  const isShowMintBtn = useMemo(() => {
    return (
      itemData &&
      !itemData?.token_id_onchain &&
      !itemData?.token_mint_pending &&
      rankCode !== "0.01" &&
      itemData?.item_type !== ITEM_TYPES.ITEM_TYPE_PRIME
    );
  }, [itemData, rankCode]);
  const isShowPendingBtn = useMemo(() => {
    return (
      itemData &&
      !itemData?.token_id_onchain &&
      itemData?.token_mint_pending &&
      rankCode !== "0.01" &&
      itemData?.item_type !== ITEM_TYPES.ITEM_TYPE_PRIME
    );
  }, [itemData, rankCode]);

  const handleMint = async () => {
    try {
      const resultDexWallet = await getDexWallet();
      if (
        resultDexWallet &&
        resultDexWallet.data &&
        resultDexWallet.data.data &&
        resultDexWallet.data.data.public_address
      ) {
        navigate(
          `/mint-nft?item_code=${itemData?.token}&nft_type=${itemData?.tag_nft_type}`
        );
      } else {
        setIsShowCreatWeb3(true);
      }
    } catch (e) {
      setIsShowCreatWeb3(true);
    }
  };
  const handleViewSub = () => {
    navigate(
      `/asset?type=subscription&typesub=suzu_plus&item_id=${itemData?.id}`
    );
  };
  const handleChangeDescription = async () => {
    if (loading) return;
    setLoading(true);
    const result = await postChangeDescriptionNft({
      internalTokenId: itemData?.token,
      description: description || "",
    });
    setLoading(false);

    if (result?.data?.error?.status) {
      setIsDesEdit(false);
    } else {
      Notification.error(t("Update unsuccessfully."));
    }
  };
  const handleChangeName = async () => {
    if (loading) return;
    setLoading(true);
    const result = await postChangeNameNft({
      internalTokenId: itemData?.token,
      name: name || "",
    });
    setLoading(false);

    if (result?.data?.error?.status) {
      setIsNameEdit(false);
      loadData();
      Notification.success(t("Update successfully."));
    } else {
      Notification.error(t("Update unsuccessfully."));
    }
  };

  return (
    <Container className="bg-[#fff]">
      <ContainerView background="transparent" style={{ minHeight: "unset" }}>
        <div className="flex justify-start gap-3 items-center">
          <div onClick={() => back()}>
            <ArrowDownIcon className="rotate-90 w-[20px] h-[20px] cursor-pointer stroke-black" />
          </div>
          <TitlePage>{t("Item Detail")}</TitlePage>
        </div>
        {isOpenModalConfirm && (
          <ModalConfirmSync
            title={
              itemData?.position ==
              ITEM_POSITION_ENUMS.ITEM_POSITION_MARKETPLACE
                ? t("Sync to app")
                : t("Move item to C2C market")
            }
            des={
              itemData?.position ==
              ITEM_POSITION_ENUMS.ITEM_POSITION_MARKETPLACE
                ? t(
                    "Are you sure you want to sync this avatar to AI Avatar app? After being synced successfully, this item will be removed from C2C market and you can walk this avatar on app or you can move this item to C2C market again."
                  )
                : t(
                    "Are you sure you want to move this avatar to C2C market? After being moved successfully, this item will be removed from AI Avatar app and you can list it for sales on C2C market or you can sync this item to app again."
                  )
            }
            onClose={() => setIsOpenModalConfirm(false)}
            onSubmit={() => handleMoveItem(itemData)}
          />
        )}
        {isOpenModalSubAlert && (
          <ModalSubAlert
            title={t("Move item to C2C market")}
            des={t(
              "The item still has active Art Plus subscription. Please cancel subscription before you move it to C2C market"
            )}
            onClose={() => setIsOpenModalSubAlert(false)}
          />
        )}
        {isShowCreateWeb3 && (
          <ModalMintNotify
            onClose={() => setIsShowCreatWeb3(false)}
            onSubmit={() => hanldeCreateWeb3Address()}
            isLoading={isBtnLoading}
            title={t("AI Avatar Web3 Wallet not created!")}
            des={t(
              "You have not created AI Avatar Web3 Wallet to store NFT. Please create a AI Avatar Wallet and try again!"
            )}
            buttonText={t("Create Web3 Wallet")}
          />
        )}
        {isShowCreateWeb3Success && (
          <ModalMintNotify
            onClose={() => setIsShowCreatWeb3Success(false)}
            onSubmit={() => handleMint()}
            title={t("Created Web3 Wallet successfully!")}
            des={t(
              "Your web3 wallet has been created successfully. Now you can withdraw SOT from AMS to AI Avatar Web3 Wallet. You can view web3 wallet in AI Avatar application."
            )}
            buttonText={t("Continue to mint")}
          />
        )}
      </ContainerView>
      <div className="flex px-[15px] lg:px-[32px] max-w-[1920px] flex-wrap lg:flex-nowrap mx-auto justify-start items-start xls:gap-[50px] gap-4 lg:gap-[30px] mt-[30px]">
        <div className="flex-1 w-full item-earner-left lg:sticky lg:top-5 max-w-[1300px] mx-auto">
          <div className={`item-left-inner relative`}>
            {itemData?.tag_nft_type == "motion" ? (
              <>
                {!isMobile ? <div className="padding-earner"></div> : <></>}
                <div className="lg:absolute flex flex-col justify-center items-center inset-0">
                  {size.width < 768 ? (
                    <VideoPlayer
                      source={itemData?.long_video_url}
                      className={"flex justify-center"}
                      isShowNft={itemData?.token_id_onchain}
                    />
                  ) : (
                    <CustomVideo
                      source={itemData?.long_video_url}
                      className={"flex justify-center"}
                      isShowControls={true}
                      isShowNft={itemData?.token_id_onchain}
                      randomClass={randomClass}
                    />
                  )}
                </div>
              </>
            ) : (
              <>
                {!isMobile ? <div className="padding-earner"></div> : <></>}
                <div className="relative lg:absolute flex flex-col justify-center items-center inset-0">
                  <ImageCustom
                    src={
                      itemData?.original_img_url ??
                      itemData?.fullscreen_img_url ??
                      itemData?.img
                    }
                    srcSmall={itemData?.img}
                    isShowFullscreen={true}
                    isShowNft={itemData?.token_id_onchain}
                    isShowFree={itemData?.is_free == 1}
                    isShowSub={subData?.length > 0}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="w-full lg:w-[450px] item-earner-right">
          <div className="rounded-[20px] h-[100%]">
            <div className="p-0">
              <div className="block-item-right-head pb-[20px] lg:pb-[24px] mb-[20px] lg:mb-[32px] border-b border-solid border-[#E0E0E0]">
                <div className="flex-col justify-between items-start">
                  <div className="flex flex-col">
                    {!isNameEdit ? (
                      <div className="text-[#000000] text-[20px] leading-[35px] mb-[5px] font-semibold font-manrope flex items-center gap-2">
                        <span>{itemData?.name || breadName}</span>
                        <span
                          className="inline-block cursor-pointer"
                          onClick={() => {
                            setIsNameEdit(!isNameEdit);
                            setName(itemData?.name);
                          }}
                        >
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.9459 3.61055C17.5332 3.02328 17.8268 2.72965 18.1521 2.58923C18.6208 2.38692 19.1521 2.38692 19.6208 2.58923C19.946 2.72965 20.2397 3.02328 20.8269 3.61055C21.4142 4.19782 21.7079 4.49145 21.8483 4.81675C22.0506 5.2854 22.0506 5.81674 21.8483 6.28539C21.7079 6.61069 21.4142 6.90432 20.8269 7.49159L15.8054 12.5132C14.5682 13.7504 13.9496 14.369 13.1748 14.7355C12.4 15.102 11.5294 15.1879 9.78823 15.3597L9 15.4375L9.07778 14.6493C9.24958 12.9081 9.33549 12.0375 9.70201 11.2627C10.0685 10.4879 10.6871 9.86933 11.9243 8.63214L16.9459 3.61055Z"
                              stroke="#474747"
                              strokeWidth="1.5"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M6 15.4375H3.75C2.7835 15.4375 2 16.221 2 17.1875C2 18.154 2.7835 18.9375 3.75 18.9375H13.25C14.2165 18.9375 15 19.721 15 20.6875C15 21.654 14.2165 22.4375 13.25 22.4375H11"
                              stroke="#474747"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    ) : (
                      <div className="name-input relative mb-3">
                        <FormInput
                          type="textarea"
                          placeholder={t("Enter a name here ...")}
                          className="input-mint item-name py-[10px] !text-black"
                          value={name}
                          disabled={!isNameEdit}
                          autoSize={{ minRows: 1 }}
                          onChange={(e) => changeName(e.target.value)}
                        />
                        {isNameEdit && (
                          <div
                            className="absolute right-2 top-3 cursor-pointer"
                            onClick={() => handleChangeName()}
                          >
                            <IconSend
                              className={
                                "lg:w-[24px] lg:h-[24px] w-[24px] h-[24px]"
                              }
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-between items-start">
                    {itemData?.item_type !== ITEM_TYPES.ITEM_TYPE_PRIME && (
                      <div className="h-[37px]">
                        <span
                          className={`rounded-[30px] px-[6px] text-[13px]/[28px] inline-block xs:px-[10px] lg:px-[19px] py-[0]
                          lg:text-[13px]/[30px] xls:text-[14px]/[30px] 
                          ${
                            itemData?.position ==
                            ITEM_POSITION_ENUMS.ITEM_POSITION_APP
                              ? "tag-inapp"
                              : "tag-inmarket"
                          }`}
                        >
                          {itemData?.position ==
                          ITEM_POSITION_ENUMS.ITEM_POSITION_APP
                            ? t("In app")
                            : t("In market")}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="flex mt-[8px] lg:mt-[16px] justify-between items-center">
                    {price > 0 && (
                      <div className="text-[20px] lg:text-[24px] text-black xls:leading-[36px] font-semibold font-manrope">
                        <NumberFormat
                          value={price}
                          displayType={"text"}
                          thousandSeparator={thousandSeparatorByCurrency(
                            getCurrency()
                          )}
                          decimalSeparator={decimalSeparatorByCurrency(
                            getCurrency()
                          )}
                          prefix={prefixCcySymbol(true, getCurrency())}
                          suffix={suffixCcySymbol(true, getCurrency())}
                          decimalScale={decimalScaleByCurrency(
                            baseCurrencyCode(true, getCurrency())
                          )}
                        />
                      </div>
                    )}
                    {isShowMintBtn ? (
                      <div className="grow flex justify-end">
                        <button
                          type="button"
                          onClick={() => handleMint()}
                          className="bg-black leading-[25px] lg:leading-[40px] !text-white lg:min-w-[145px] rounded-[5px] text-xs lg:text-sm lg:rounded-[10px] px-[10px] h-[30px] lg:h-[40px] button-boxshadow lg:mt-[5px] mt-[2px]"
                        >
                          {t("Mint NFT")}
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                    {isShowPendingBtn ? (
                      <div className="grow flex justify-end">
                        <button
                          type="button"
                          disabled
                          className="bg-black  opacity-40 leading-[25px] lg:leading-[40px] !text-white lg:min-w-[145px] rounded-[5px] text-xs lg:text-sm lg:rounded-[10px] px-[10px] h-[25px] lg:h-[40px] button-boxshadow lg:mt-[5px] mt-[2px]"
                        >
                          {t("Mint Processing")}
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
              {itemData?.token_id_onchain && (
                <div className="properties-block mb-[30px]">
                  <div className="flex justify-between items-center mb-[12px]">
                    <span className="text-black text-[22px]/[30px] lg:text-[18px]/[26px] font-bold font-manrope">
                      {t("Description")}
                    </span>
                  </div>
                  <div className="description-input">
                    <FormInput
                      type="textarea"
                      placeholder={t("Enter a description here ...")}
                      className="input-mint description py-[10px] !text-black"
                      value={description}
                      disabled={!isDesEdit}
                      autoSize={{ minRows: 3 }}
                      onChange={(e) => changeDescription(e.target.value)}
                    />
                    <div
                      className="description-edit-icon cursor-pointer"
                      onClick={() => setIsDesEdit(!isDesEdit)}
                    >
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.9459 3.61055C17.5332 3.02328 17.8268 2.72965 18.1521 2.58923C18.6208 2.38692 19.1521 2.38692 19.6208 2.58923C19.946 2.72965 20.2397 3.02328 20.8269 3.61055C21.4142 4.19782 21.7079 4.49145 21.8483 4.81675C22.0506 5.2854 22.0506 5.81674 21.8483 6.28539C21.7079 6.61069 21.4142 6.90432 20.8269 7.49159L15.8054 12.5132C14.5682 13.7504 13.9496 14.369 13.1748 14.7355C12.4 15.102 11.5294 15.1879 9.78823 15.3597L9 15.4375L9.07778 14.6493C9.24958 12.9081 9.33549 12.0375 9.70201 11.2627C10.0685 10.4879 10.6871 9.86933 11.9243 8.63214L16.9459 3.61055Z"
                          stroke="#474747"
                          strokeWidth="1.5"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6 15.4375H3.75C2.7835 15.4375 2 16.221 2 17.1875C2 18.154 2.7835 18.9375 3.75 18.9375H13.25C14.2165 18.9375 15 19.721 15 20.6875C15 21.654 14.2165 22.4375 13.25 22.4375H11"
                          stroke="#474747"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="description-length flex space-x-2 items-center">
                      <div className="mt-[10px]">
                        {description.length || 0}/5000
                      </div>
                      {isDesEdit && (
                        <div
                          className="submit-des"
                          onClick={() => handleChangeDescription()}
                        >
                          <IconSend
                            className={
                              "lg:w-[34px] lg:h-[34px] w-[24px] h-[24px]"
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {itemData?.item_type === ITEM_TYPES.ITEM_TYPE_PRIME ? (
                <>
                  <div className="properties-block">
                    <div className="flex justify-between items-center mb-[12px]">
                      <span className="text-black text-[22px]/[30px] lg:text-[18px]/[26px] font-bold font-manrope">
                        {t("Information")}
                      </span>
                      <span onClick={() => setOpenProperties(!openProperties)}>
                        <svg
                          width="24"
                          className={`w-[16px] cursor-pointer ${
                            openProperties ? "rotate-180" : ""
                          }`}
                          height="14"
                          viewBox="0 0 24 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 2L12 12L22 2"
                            stroke="black"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    {openProperties && (
                      <>
                        <div className="flex items-center justify-between grow-1">
                          <span className="text-[14px] lg:text-[16px] text-[#989898]">
                            {t("ID")}
                          </span>
                          <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                            #{itemData?.id}
                          </span>
                        </div>
                        {itemData?.token_id_onchain &&
                        metadataOnchain?.hadPrintLicense !== undefined ? (
                          <div className="flex items-center justify-between grow-1">
                            <span className="text-[14px] lg:text-[16px] text-[#989898]">
                              {t("One-Time Print License")}
                            </span>
                            <span className="h-[36px] text-center text-[14px] lg:text-[16px]  leading-[36px]">
                              {metadataOnchain?.hadPrintLicense === true
                                ? t("Available")
                                : t("Not Available")}
                            </span>
                          </div>
                        ) : (
                          <></>
                        )}
                        {/* <div className="flex items-center justify-between grow-1">
                        <span className="text-[14px] lg:text-[16px] text-[#989898]">
                          {t("ART PRIME ID")}
                        </span>
                        <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                          {rankName || ""}
                        </span>
                      </div>  */}
                        <div className="flex items-center justify-between grow-1">
                          <span className="text-[14px] lg:text-[16px] text-[#989898]">
                            {t("Received Date")}
                          </span>
                          <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                            {itemData?.buy_time
                              ? dateFormat(
                                  itemData?.buy_time,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              : ""}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <div className="properties-block">
                  <div className="flex justify-between items-center mb-[12px]">
                    <span className="text-black text-[22px]/[30px] lg:text-[18px]/[26px] font-bold font-manrope">
                      {t("Properties")}
                    </span>
                    <span onClick={() => setOpenProperties(!openProperties)}>
                      <svg
                        width="24"
                        className={`w-[16px] cursor-pointer ${
                          openProperties ? "rotate-180" : ""
                        }`}
                        height="14"
                        viewBox="0 0 24 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 2L12 12L22 2"
                          stroke="black"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  {openProperties && (
                    <>
                      <div className="flex items-center justify-between grow-1">
                        <span className="text-[14px] lg:text-[16px] text-[#989898]">
                          {t("ID")}
                        </span>
                        <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                          #{itemData?.id}
                        </span>
                      </div>
                      {metadataOnchain?.hadPrintLicense === false &&
                      itemData?.token_id_onchain ? (
                        <div className="flex items-center justify-between grow-1">
                          <span className="text-[14px] lg:text-[16px] text-[#989898]">
                            {t("One-Time Print License")}
                          </span>
                          <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                            {t("Not Available")}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                      {categorySelected &&
                      categorySelected.collectionType !== 0 ? (
                        <></>
                      ) : (
                        <>
                          <div className="flex items-center justify-between grow-1">
                            <span className="text-[14px] lg:text-[16px] text-[#989898]">
                              {t("Gender")}
                            </span>
                            <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                              {itemData?.sex == 1 ? (
                                <>
                                  <div className="flex justify-end items-center">
                                    <IconFemale /> {t("Male")}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="flex justify-end items-center">
                                    <IconFemale /> {t("Female")}
                                  </div>
                                </>
                              )}
                            </span>
                          </div>
                        </>
                      )}
                      <div className="flex items-center justify-between grow-1">
                        <span className="text-[14px] lg:text-[16px] text-[#989898]">
                          {t("Rank")}
                        </span>
                        <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                          {rankName || ""}
                        </span>
                      </div>
                      {categorySelected &&
                      itemData?.edition_number > 0 &&
                      categorySelected.collectionType !== 0 ? (
                        <>
                          <div className="flex items-center justify-between grow-1">
                            <span className="text-[14px] lg:text-[16px] text-[#989898]">
                              {t("Edition")}
                            </span>
                            <span className="h-[36px] text-[#F12E11] font-semibold text-center text-[14px] lg:text-[16px] leading-[36px]">
                              {itemData?.edition_number}
                              {itemData?.box_total
                                ? `/${itemData?.box_total}`
                                : ""}
                            </span>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className="flex items-center justify-between grow-1">
                        <span className="text-[14px] lg:text-[16px] text-[#989898]">
                          {t("Type")}
                        </span>
                        <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                          {itemData?.tag_nft_type
                            ? itemData?.tag_nft_type == "motion"
                              ? t("Motion Art")
                              : t("Photo Art")
                            : ""}
                        </span>
                      </div>
                      {itemData?.tag_nft_type == "motion" ? (
                        <div className="flex items-center justify-between grow-1">
                          <span className="text-[14px] lg:text-[16px] text-[#989898]">
                            {t("Author")}
                          </span>
                          <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                            {metadataOnchain?.author ?? itemData?.author}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className="flex items-center justify-between grow-1">
                        <span className="text-[14px] lg:text-[16px] text-[#989898]">
                          {t("Collection")}
                        </span>
                        <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                          {collectionName}
                        </span>
                      </div>
                      {itemData?.token_id_onchain && (
                        <>
                          <div className="flex items-center justify-between grow-1">
                            <span className="text-[14px] lg:text-[16px] text-[#989898]">
                              {t("Token ID")}
                            </span>
                            <span className="h-[36px] text-center text-[14px] lg:text-[16px] text-[#F3850F] leading-[36px]">
                              {metadataOnchain?.tokenId || ""}
                            </span>
                          </div>
                          {metadataOnchain?.hadPrintLicense === true ? (
                            <div className="flex items-center justify-between grow-1">
                              <span className="text-[14px] lg:text-[16px] text-[#989898]">
                                {t("One-Time Print License")}
                              </span>
                              <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                                {t("Available")}
                              </span>
                            </div>
                          ) : (
                            <></>
                          )}
                          <div className="flex items-center justify-between grow-1">
                            <span className="text-[14px] lg:text-[16px] text-[#989898]">
                              {t("Contract address")}
                            </span>
                            <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                              {metadataOnchain?.contractAddress ? (
                                <div className="w-[150px]">
                                  <Copy
                                    textStyle={{
                                      fontWeight: 400,
                                      fontSize: 16,
                                      color: "#F3850F",
                                    }}
                                    cutText={true}
                                    splitFont={5}
                                    numDot={3}
                                    text={metadataOnchain?.contractAddress}
                                    icon={<CopyIcon3 />}
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                            </span>
                          </div>
                          <div className="flex items-center justify-between grow-1">
                            <span className="text-[14px] lg:text-[16px] text-[#989898]">
                              {t("Network")}
                            </span>
                            <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                              {metadataOnchain?.network || ""}
                            </span>
                          </div>
                          <div className="flex items-center justify-between grow-1">
                            <span className="text-[14px] lg:text-[16px] text-[#989898]">
                              {t("Birthday")}
                            </span>
                            <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                              {metadataOnchain?.birthday
                                ? dateFormat(
                                    metadataOnchain?.birthday,
                                    "YYYY-MM-DD"
                                  )
                                : ""}
                            </span>
                          </div>
                          <div className="flex items-center justify-between grow-1">
                            <span className="text-[14px] lg:text-[16px] text-[#989898]">
                              {t("NFT Information")}
                            </span>
                            <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                              {metadataOnchain?.detailPageUrl ? (
                                <div className="w-[210px]">
                                  <Copy_Link
                                    textStyle={{
                                      fontWeight: 400,
                                      fontSize: 16,
                                      color: "#F3850F",
                                    }}
                                    cutText={true}
                                    splitFont={16}
                                    splitFontLg={16}
                                    numDot={3}
                                    text={metadataOnchain?.detailPageUrl}
                                    icon={<CopyIcon3 />}
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                            </span>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}
              {itemData?.item_type === ITEM_TYPES.ITEM_TYPE_PRIME ? (
                <div className="properties-block mt-5">
                  <div className="flex justify-between items-center mb-[12px]">
                    <span className="text-black text-[22px]/[30px] lg:text-[18px]/[26px] font-bold font-manrope">
                      {t("Minting")}
                    </span>
                    <span onClick={() => setOpenMintings(!openMintings)}>
                      <svg
                        width="24"
                        className={`w-[16px] cursor-pointer ${
                          openProperties ? "rotate-180" : ""
                        }`}
                        height="14"
                        viewBox="0 0 24 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 2L12 12L22 2"
                          stroke="black"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  {openMintings && (
                    <>
                      <div className="flex items-center justify-between grow-1">
                        <span className="text-[14px] lg:text-[16px] text-[#989898]">
                          {t("Status")}
                        </span>
                        <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                          {itemData?.token_id_onchain
                            ? t("Minted")
                            : t("Unmint")}
                        </span>
                      </div>
                      {metadataOnchain?.birthday ? (
                        <div className="flex items-center justify-between grow-1">
                          <span className="text-[14px] lg:text-[16px] text-[#989898]">
                            {t("Birthday")}
                          </span>
                          <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                            {metadataOnchain?.birthday
                              ? dateFormat(
                                  metadataOnchain?.birthday,
                                  "YYYY-MM-DD"
                                )
                              : ""}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <>
                  {subData?.length > 0 && currentSub && (
                    <div className="properties-block mt-[20px] lg:mb-[30px]">
                      <div className="flex justify-between items-center mb-[12px] lg:mb-[22px]">
                        <span className="text-black text-[22px]/[30px] lg:text-[18px]/[26px] font-bold font-manrope">
                          {t("ART PLUS")}
                        </span>
                      </div>
                      <div className="property-content">
                        <div className="flex justify-between space-x-2">
                          <div className="sub-image min-w-[83px] w-[83px] h-[83px] rounded-[10px] overflow-hidden">
                            <img
                              src={currentSub.product_image}
                              alt=""
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <div className="max-w-[206px] flex w-full flex-col">
                            <div className="flex justify-between leading-[21px] space-x-3 items-center">
                              <div className="text-[#989898] font-normal text-[12px] min-w-[100px]">
                                {t("Quantity:")}
                              </div>
                              <div className="text-[#101828] font-medium text-[12px] ">
                                {totalSub}
                              </div>
                            </div>
                            <div className="flex justify-between leading-[21px] space-x-3 mt-[6px] items-center">
                              <div className="text-[#989898] font-normal text-[12px] min-w-[100px]">
                                {t("Monthly subtotal:")}
                              </div>
                              <div className="text-[#101828] font-medium text-[12px]">
                                <NumberFormat
                                  value={subTotalPrice}
                                  displayType={"text"}
                                  thousandSeparator={thousandSeparatorByCurrency(
                                    getCurrency()
                                  )}
                                  decimalSeparator={decimalSeparatorByCurrency(
                                    getCurrency()
                                  )}
                                  prefix={prefixCcySymbol(true, getCurrency())}
                                  suffix={suffixCcySymbol(true, getCurrency())}
                                  decimalScale={validateDecimalSeparator(
                                    baseCurrencyCode(true, getCurrency())
                                  )}
                                />
                              </div>
                            </div>
                            <div className="flex justify-start lg:justify-end mt-[16px]">
                              <button
                                type="button"
                                className="bg-white leading-[36px] text-black border border-solid border-black  rounded-[8px]  px-[20px] h-[36px] font-medium"
                                onClick={() => handleViewSub()}
                              >
                                {t("View detail")}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {opportunityTokens?.length > 0 && (
                    <div className="properties-block mt-[20px]">
                      <div className="flex justify-between items-center mb-[12px]">
                        <span className="text-black text-[22px]/[30px] lg:text-[18px]/[26px] font-bold font-manrope">
                          {t("Opportunity token")}
                        </span>
                        <span
                          onClick={() =>
                            setOpenOpportunityTokens(!openOpportunityTokens)
                          }
                        >
                          <svg
                            width="24"
                            className={`w-[16px] cursor-pointer ${
                              openOpportunityTokens ? "rotate-180" : ""
                            }`}
                            height="14"
                            viewBox="0 0 24 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2 2L12 12L22 2"
                              stroke="black"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      {openOpportunityTokens && (
                        <>
                          {opportunityTokens.map((opportunity, index) => (
                            <div
                              className="flex items-center justify-between grow-1"
                              key={index}
                            >
                              <span className="text-[14px] lg:text-[16px] text-[#989898]">
                                {opportunity.currency}
                              </span>
                              <span className="h-[36px] text-center text-[14px] lg:text-[16px] leading-[36px]">
                                {opportunity.balance
                                  ? formatCurrency(
                                      opportunity.balance,
                                      2,
                                      getCurrency()
                                    )
                                  : 0}
                              </span>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  )}
                  <div className="w-full mt-[32px]">
                    {subData?.length > 0 && (
                      <a
                        href={`${currentSub?.shopifySubUrl}`}
                        target="_blank"
                        rel="noreferrer"
                        className="w-full bg-white !text-[#101828] flex justify-center items-center text-[16px] xls:text-[20px] font-[500] border 
                      rounded-[15px] px-[20px]  py-[8px] lg:py-[11px] border-solid border-[#000000] mb-[15px]"
                        type="button"
                      >
                        {t("View subscription on mall")}
                      </a>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
